import { v4 as uuidv4 } from 'uuid';

const imageFormat = [
    {
        idSoft: uuidv4(),
        name: 'Ajuster',
        value: 0,
        action: (style, type="image") => {
            if (type == "image") {
                style.backgroundSize = 'contain';
            }
            else {
                style.objectFit = 'contain';
            }
            return style;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'Rempli',
        value: 1,
        action: (style, type ="image") => {
            if (type == "image") {
                style.backgroundSize = 'cover';
            }
            else {
                style.objectFit = 'cover';
            }
            return style;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'Etirer',
        value: 2,
        action: (style, type ="image") => {
            if (type == "image") {
                style.backgroundSize = '100% 100%';
            }
            else {
                style.objectFit = 'fill';
            }
            return style;
        }
    },
]
export default imageFormat;
